<template>
  <div>
    <div class="container">
      <div class="row width_full">
        <div class="col_12">
          <div class="customer_content">
            <div class="common_subtitle pb_20">
              <h3 class="mb_0">{{ thisPageType ? thisPageType.name : '' }}</h3>
              <span class="ml_10" v-if="thisPageType">
                <button class="btn btn_success btn_sm" @click.prevent="editPage()">Edit</button>
              </span>
              <router-link class="btn btn_success" style="float: right" :to="{name:'pages_add', params:{type:this.$route.params.type}}">Add New Page</router-link>
              <router-link class="btn btn_success mr_10" style="float: right" :to="{name:'pages_sort', params:{type:this.$route.params.type}}">Sort Page</router-link>
            </div>
            <div class="row">
              <div class="col_12">
                <table-component
                    :columns="columns"
                    :rows="pages"
                    :header="true"
                    :centralized="true"
                    :sortable="sortable"
                    :pagination="pagination"
                    :searchShowStatus="true"
                    :perPageShowStatus="true"
                    @queryEvent="queryEvent"
                    @sorting="sorting"
                    @pageChanged="pageChanged">
                  <template v-slot:image="{ row }">
                    <span class="color_blue item_size_delete">
                      <div class="form-group media_wrap" v-if="row.file_type == 'image'">
                        <img :src="row.image" alt=""   width="150">
                      </div>
                      <div class="form-group media_wrap" v-if="row.file_type == 'video'">
                        <video   width="150" :src="row.image" controls>
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </span>
                  </template>
                  <template v-slot:action="{ row }">
                    <router-link :to="{name:'page_edit', params:{id:row.id, type:this.$route.params.type}}" class="btn btn_success mr_10"> Edit</router-link>
                    <span v-if="row.sub_page && row.sub_page.length" @click="showChildPage(row)" class="btn btn_blue">Child Page</span>
                    <span class="ml_10 btn btn_danger cursor_pointer" @click.prevent="deleteRecord(row)">Delete</span>
                  </template>
                </table-component>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-component
        v-if="showModal"
        :modal-size="'custom_modal_1200p'"
        :header-classes="'display_table white_bg no_border pa15 pb_0'"
        :content-classes="'pl_15 pr_15'"
        @closeModal="closeModal"
    >
      <template #header>
        <span class="modal_header_title">{{ currentViewPage ? currentViewPage.name +" child pages" : ''}}</span>
      </template>
      <template #content>
        <div class="row">
          <div class="col_12" v-if="currentViewPage.sub_page">
            <table-component
                :columns="columns"
                :rows="currentViewPage.sub_page"
                :header="true"
                :centralized="true"
                :sortable="sortable"
                :pagination="pagination"
                :searchShowStatus="false"
                :perPageShowStatus="false"

            >
              <template v-slot:image="{ row }">
                    <span class="color_blue item_size_delete">
                      <div class="form-group media_wrap" v-if="row.file_type == 'image'">
                        <img :src="row.image" alt=""   width="150">
                      </div>
                      <div class="form-group media_wrap" v-if="row.file_type == 'video'">
                        <video   width="150" :src="row.image" controls>
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </span>
              </template>
              <template v-slot:action="{ row }">
                <router-link :to="{name:'page_edit', params:{id:row.id, type:this.$route.params.type}}" class="btn btn_success mr_10"> Edit</router-link>
                <span class="ml_10 btn btn_danger cursor_pointer" @click.prevent="deleteRecord(row)">Delete</span>
              </template>
            </table-component>
          </div>
        </div>
      </template>
    </modal-component>

    <modal-component
        v-if="showParentPageEditModal"
        :modal-size="'custom_modal_1200p'"
        :header-classes="'display_table white_bg no_border pa15 pb_0'"
        :content-classes="'pl_15 pr_15'"
        @closeModal="closeModal"
    >
      <template #header>
        <span class="modal_header_title">Edit Page</span>
      </template>
      <template #content>
        <div class="row">
          <div class="col_6">
            <div :class="['form-group', {'has_error': errorFor('name')}]">
              <label>Name (Korean)</label>
              <input type="text" class="form_global" placeholder="Name Korean" v-model="parentPageData.name">
              <template v-if="errors && errors.name">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.name" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
          </div>
          <div class="col_6">
            <div :class="['form-group']">
              <label>Status</label>
              <select  class="form_global" v-model="parentPageData.status">
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
          </div>
          <div class="col_12">
            <div :class="['form-group', {'has_error': errorFor('description')}]">
              <label>Description</label>
              <text-editor v-model:text="parentPageData['description']" :id="'description3'"></text-editor>
              <template v-if="errors && errors.description">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.description" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
          </div>
          <div class="col_12">
            <div class="d_flex_end">
              <button class="btn btn_common" @click.prevent="updateParentPage()">Update</button>
            </div>
          </div>
        </div>
      </template>
    </modal-component>
  </div>
</template>

<script>
import TableComponent from "../../components/shared/TableComponent";
import ModalComponent from "../../components/shared/ModalComponent";
import TextEditor from "../../components/shared/TextEditor";
import {mapGetters} from "vuex";
export default {
  name: "Index",
  components: {ModalComponent, TableComponent, TextEditor},
  data(){
    return {
      showModal:false,
      currentViewPage: null,
      thisPageType: null,
      pages: [],
      sort: '1',
      sortable: {
        order: 'id',
        sort: 'desc'
      },
      filter: {
        status: '',
        per_page: 10
      },
      columns: [
        {
          label: "Name",
          field: "name",
          sortable: true
        },
        {
          label: "Created Date",
          field: "created_at",
          sortable: false,
          slot: false,
        },
        {
          label: "Action",
          field: 'action',
          sortable: false,
          slot: true,
        }
      ],
      pagination: null,
      queryParams: {
        page: 1,
        per_page: 10,
        search: '',
        search_columns: 'name',
        sort: '',
        sort_order: '',
        page_type: this.$route.params.type,
      },
      showParentPageEditModal: false,
      parentPageData:{
        name: '',
        description: '',
        status: 1,
        page_type: this.$route.params.type
      },
    }
  },
  created() {
    this.loadData()
    this.loadParentPageData()
  },
  watch: {
    queryParams: {
      deep: true,
      handler() {
        this.loadData()
      }
    },
    "$route.params.type": {
      deep: true,
      handler() {
        this.queryParams.page_type = this.$route.params.type
        this.loadData()
        this.makeEmptyParentPage()
        this.loadParentPageData()
      }
    },
    pageTypes:{
      deep: true,
      handler() {
        this.switchCurrentPageType()
      }
    }
  },
  computed:{
    ...mapGetters({
      pageTypes: 'getPageTypes'
    })
  },
  methods:{
    closeModal(){
      this.showModal = false
      this.currentViewPage = null
      this.showParentPageEditModal = false
    },
    showChildPage(page){
      this.currentViewPage = page
      this.showModal = true
    },
    switchCurrentPageType(){
      this.thisPageType = this.pageTypes.find((item) => parseInt(item.id) === parseInt(this.$route.params.type))
    },
    sorting({column, order}) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
    },
    pageChanged(page) {
      this.queryParams.page = page;
    },
    queryEvent(query){
      this.queryParams.search = query.search
      this.queryParams.per_page = query.per_page
    },
    loadData(){
      this.axios.get('/pages', {
        params: {...this.queryParams}
      }).then((response) => {
        this.switchCurrentPageType()
        this.pages = response.data.data;
        this.pagination = response.data.meta;
      })
    },
    deleteRecord(row) {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/pages/'+row.id).then(() => {
            this.$swal.fire(
                'Deleted',
                'Page has been deleted!',
                'success'
            )
            this.loadData();
            this.showModal = false
          });
        }
      });
    },
    loadParentPageData(){
      this.axios.get('/parent-page', {params:{page_type:this.$route.params.type}})
          .then((response) => {
            this.parentPageData = response.data.data
          })
    },
    makeEmptyParentPage(){
      this.parentPageData = {
        name: '',
        description: '',
        status: 1,
        page_type: this.$route.params.type
      }
    },
    editPage(){
      this.showParentPageEditModal = true
    },
    updateParentPage(){
      this.errors = null;
      this.loading = true;

      let formData = new FormData()

      Object.keys(this.parentPageData).forEach(key => {
        formData.append(key, this.parentPageData[key] ? this.parentPageData[key] : '');
      })

      this.axios.post('/parent-page/update', formData)
          .then(() => {
            this.showParentPageEditModal = false;
            this.showSuccessMsg("Updated Successfully!");
          })
          .catch((err) => {
            this.errors = err.response.data.errors
          })
          .finally(() => {
            this.loading = false;
          })
    }
  },
}
</script>
